// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__3YumD","back-stars":"Rating_back-stars__1sUye","front-stars":"Rating_front-stars__1_1MZ"};